import { type FC, useCallback } from 'react';

import { Button } from '@vakantiesnl/components/src/atoms/Button';
import { Divider } from '@vakantiesnl/components/src/atoms/Divider';
import { message } from '@vakantiesnl/components/src/utils/message';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';

import { useCustomStyles } from './FlexibleDepartureDate.style';

export type Props = {
	flexibleDepartureDate?: number;
	flexibleDepartureDateButtonsActive?: boolean;
	onFlexDepartureDateSelect: (value: number) => void;
};

export const FlexibleDepartureDate: FC<Props> = ({
	flexibleDepartureDate,
	flexibleDepartureDateButtonsActive,
	onFlexDepartureDateSelect,
}): JSX.Element => {
	const microCopies = useMicroCopyContext();
	const { classes } = useCustomStyles();

	const handleFlexibleDepartureDateButtonClick = useCallback(
		(value: number) => () => {
			onFlexDepartureDateSelect(value);
		},
		[onFlexDepartureDateSelect],
	);

	return (
		<>
			<Divider />
			<div className={classes.buttonWrapper}>
				<Button
					active={flexibleDepartureDate === 0}
					disabled={!flexibleDepartureDateButtonsActive}
					onClick={handleFlexibleDepartureDateButtonClick(0)}
					size="small"
					variant="secondary"
				>
					{microCopies['calendar.exactdate']}
				</Button>
				<Button
					active={flexibleDepartureDate === 1}
					disabled={!flexibleDepartureDateButtonsActive}
					onClick={handleFlexibleDepartureDateButtonClick(1)}
					size="small"
					variant="secondary"
				>
					&#177;{' '}
					{message(microCopies['calendar.adddays'], {
						count: 1,
					})}
				</Button>
				<Button
					active={flexibleDepartureDate === 2}
					disabled={!flexibleDepartureDateButtonsActive}
					onClick={handleFlexibleDepartureDateButtonClick(2)}
					size="small"
					variant="secondary"
				>
					&#177;{' '}
					{message(microCopies['calendar.adddays'], {
						count: 2,
					})}
				</Button>
			</div>
		</>
	);
};
